

export class ReloadManager {

	tmr = null;
	inited = false;

	constructor() {
		if (this.inited)
			return;

		this.clearTmr();
		this.inited = true;
	}

	clearTmr = () => {
		if (!this.tmr)
			return;
		
		clearTimeout(this.tmr);
		this.tmr = null;
	}

	//in mis
	setReload = (mins) => {
		this.clearTmr();

		if (!mins)
			return;

		this.tmr = setTimeout( () => {
			location.reload();
		}, mins * 60 * 1000);
	}
	
	
}